export function calculateTokenPriceInUsd(tokenAmount: number, tokenPrice: number): number {
  return tokenAmount * tokenPrice
}
